import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getNonStructuredSectionsFiltersFormAction } from '../actions';

const {
  useLoaderData: useNonStructuredSectionsFiltersFormLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getNonStructuredSectionsFiltersFormAction,
});

function NonStructuredSectionsFiltersFormLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  NonStructuredSectionsFiltersFormLoader,
  useNonStructuredSectionsFiltersFormLoaderData,
};
